"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FollowCheapest_1 = require("../../model/strategy/FollowCheapest");

var FollowMode_1 = require("../../model/strategy/FollowMode");

var FollowMostExpensive_1 = require("../../model/strategy/FollowMostExpensive");

var StrategyTypeEnum_1 = require("../../model/strategy/StrategyTypeEnum");
/**
 * MultiTargetStrategyBuilder
 *
 * @author RV
 */


var MultiTargetStrategyBuilder =
/*#__PURE__*/
function () {
  function MultiTargetStrategyBuilder(type, competitorIds) {
    _classCallCheck(this, MultiTargetStrategyBuilder);

    this.type = type;
    this.competitorIds = competitorIds;
  }

  _createClass(MultiTargetStrategyBuilder, [{
    key: "build",
    value: function build() {
      switch (this.type) {
        case StrategyTypeEnum_1.StrategyTypeEnum.FollowMode:
          {
            return new FollowMode_1.FollowMode(this.competitorIds);
          }

        case StrategyTypeEnum_1.StrategyTypeEnum.FollowCheapest:
          {
            return new FollowCheapest_1.FollowCheapest(this.competitorIds);
          }

        case StrategyTypeEnum_1.StrategyTypeEnum.FollowMostExpensive:
          {
            return new FollowMostExpensive_1.FollowMostExpensive(this.competitorIds);
          }

        default:
          {
            throw new Error("Illegal argument exception for given type ".concat(this.type));
          }
      }
    }
  }]);

  return MultiTargetStrategyBuilder;
}();

exports.MultiTargetStrategyBuilder = MultiTargetStrategyBuilder;